import React from "react";
import { withStyles } from "@material-ui/styles";
import NavigationItem from "./NavigationItem";

const styles = {
  container: {
    marginTop: "2rem",
    paddingTop: "1rem",
    fontSize: "1rem",
    color: "#a5d3e7"
  }
};

const Navigation = props => (
  <div className={props.classes.container}>
    <NavigationItem reference="00" label="00 | Introduction" linkTo="intro" />
    <NavigationItem
      reference="01"
      label="01 | Spending &amp; Gaps"
      linkTo="theme1"
    />
    <NavigationItem
      reference="02"
      label="02 | Sector Landscapes"
      linkTo="theme2"
    />
    <NavigationItem
      reference="03"
      label="03 | The Role of Subsidies"
      linkTo="theme3"
    />
    <NavigationItem
      reference="04"
      label="04 | Use versus Cost"
      linkTo="theme4"
    />
    <NavigationItem reference="05" label="05 | Uneven Growth" linkTo="theme5" />
  </div>
);

export default withStyles(styles)(Navigation);
